import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Typography } from 'ui-components';
import { RETIREMENT_CALCULATOR_NAMESPACE } from '../../tools/RetirementCalculator.const';
import { RetirementCalculatorChartCardPropsModel } from '../../tools/RetirementCalculator.model';
import { RetirementCalculatorChart } from '../RetirementCalculatorChart/RetirementCalculatorChart';

import useStyles from './RetirementCalculatorChartCard.style';

const BARS_COUNT = 2;

export const RetirementCalculatorChartCard: React.FC<RetirementCalculatorChartCardPropsModel> = ({
  series,
  scaleTicks,
  barsCount = BARS_COUNT,
  barCaptions,
  highlightedBar,
  description,
  testId,
}) => {
  const c = useStyles({});
  const [t] = useTranslation(RETIREMENT_CALCULATOR_NAMESPACE, { useSuspense: false });

  return (
    <Card className={c.chartCard} testId={testId}>
      <RetirementCalculatorChart
        series={series}
        barCaptions={barCaptions ?? [t('result.bar.zus-only'), t('result.bar.with-savings')]}
        highlightedBar={highlightedBar}
        barsCount={barsCount}
        scaleTicks={scaleTicks}
        description={description}
      />

      <ul className={c.chartLegend}>
        {series.map(entry => (
          <li key={entry.key} className={c.chartLegendItem}>
            <span
              className={c.chartLegendMarker}
              style={{ backgroundColor: entry.color }}
              aria-hidden="true"
            />
            <Typography variant="body1" component="span">
              {entry.name}
            </Typography>
          </li>
        ))}
      </ul>
    </Card>
  );
};
